import { useInView } from 'react-intersection-observer';

/**
 * Custom hook to observe the intersection of an element with the viewport.
 *
 * @param {IntersectionObserverInit} options - Options for the Intersection Observer.
 * @returns {Object} - Contains a ref to attach to the element and a boolean indicating if the element is in view.
 */

interface IntersectionObserverInitOptions {
  threshold?: number | number[];
  root?: Element | null;
  rootMargin?: string;
  triggerOnce?: boolean;
}

const useIntersectionObserver = (
  options: IntersectionObserverInitOptions = {
    threshold: 0.1,
    root: null,
    rootMargin: '0px',
    triggerOnce: false,
  },
) => {
  const { ref, inView } = useInView({
    threshold: options.threshold,
    triggerOnce: options.triggerOnce,
    rootMargin: options.rootMargin,
  });

  return { ref, inView };
};

export default useIntersectionObserver;
